import { useTranslations } from "../../hooks/useTranslations";
import styles from "./Footer.module.css";

const Footer = () => {
  const { i18n } = useTranslations();

  return (
    <footer className={styles.footer}>
      <div className={styles.footerContent}>
        <span>{i18n.footer.companyName}</span>
        <span>·</span>
        <span>{i18n.footer.street}</span>
        <span>·</span>
        <span>{i18n.footer.city}</span>
        <span>·</span>
        <a href="tel:+390471317700">0471 317 700</a>
        <span>·</span>
        <a href="mailto:info@hgv.it">info@hgv.it</a>
        <span>·</span>
        <a href="https://www.hgv.it/" target="_blank">
          www.hgv.it
        </a>
      </div>
    </footer>
  );
};

export default Footer;
